<template>
  <div class="container">
    <div class="content">
      <div class="top">
        <div class="header">
          <img alt="logo" class="logo" :src="systemLogo" />
          <span class="title">{{ systemName }}</span>
        </div>
        <div class="desc">2112 核心价值 全力践行</div>
      </div>
      <div class="login">
        <template v-if="isNeedFormLogin">
          <a-form @submit="onSubmit" :form="form" :style="formStyle">
            <a-tabs size="large" :tabBarStyle="{ textAlign: 'center' }" style="padding: 0 2px">
              <a-tab-pane tab="账户密码登录" key="1">
                <a-alert
                  type="error"
                  :closable="true"
                  v-show="error"
                  :message="error"
                  showIcon
                  style="margin-bottom: 24px"
                />
                <a-form-item>
                  <a-input
                    size="large"
                    placeholder="admin"
                    v-decorator="[
                      'name',
                      { rules: [{ required: true, message: '请输入账户名', whitespace: true }] },
                    ]"
                  >
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input
                    size="large"
                    placeholder="admin"
                    type="password"
                    v-decorator="[
                      'password',
                      { rules: [{ required: true, message: '请输入密码', whitespace: true }] },
                    ]"
                  >
                    <a-icon slot="prefix" type="lock" />hao
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-button
                    :loading="logging"
                    style="width: 100%; margin-top: 24px"
                    size="large"
                    htmlType="submit"
                    type="primary"
                    >登录</a-button
                  >
                </a-form-item>
              </a-tab-pane>
            </a-tabs>
          </a-form>
        </template>
        <template v-else>
          <div class="loging-wrapper" v-if="spinning">
            <a-spin tip="加载中..." :spinning="spinning"> </a-spin>
          </div>
          <div class="loging-wrapper" v-if="!spinning && isShowError">
            {{ errorLabel }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, setToken, removeAll } from '@/utils/localstorage'
import { getLogin2DingTalk, currentUserType, kingdeeDataUser } from '@/api/login.js'
export default {
  name: 'Login',
  data() {
    return {
      form: this.$form.createForm(this),
      logging: false,
      error: '',
      two_dimension: true,
      loginTmpCode: undefined,
      code: undefined,
      hasLogin: false,
      employeeName: undefined,
      datas: {},
      isDevShow: false,
      Loginloadding: true,
      formStyle: {
        // background:'#fff',
        minHeight: '400px',
        width: '400px',
      },
      isNeedFormLogin: false,
      spinning: false,
      isShowError: false,
      errorLabel: '',
      // tabInfo: '扫码登录',
    }
  },
  computed: {
    systemLogo() {
      return this.$store.state.setting.systemLogo
    },
    systemName() {
      return this.$store.state.setting.systemName
    },
    linkList() {
      return this.$store.state.setting.footerLinks
    },
    copyright() {
      return this.$store.state.setting.copyright
    },
  },
  created() {
    // this.init()
  },
  mounted() {
    removeAll()
    this.DingTalkLogin()
    // 浏览器登录
    this.loginBrowser()
  },
  methods: {
    init() {
      // 判断环境 todo
      if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('192.168') > -1) {
        this.isDevShow = true
      }
      // 判断web token 是否有值
      if (getToken('webToken')) {
        this.$router.push('/home')
      }
    },

    onSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.logging = true
          if (values.name === '二组' && values.password === '6afe9ea8799f549d0e8cabf807a01221') {
            this.logging = false

            setToken(
              'webToken',
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqVXNlciI6eyJuaWNrIjoi6LW15Yqy6ZuEIiwib3BlbmlkIjpudWxsLCJ1bmlvbmlkIjoieW04UDdRZzB4MUVLOHlSSmxiUHMxUWlFaUUiLCJ1c2VyaWQiOiIwNTQxNTU2ODM5MzU0OTU1NTkiLCJ1c2VySW1nIjoiaHR0cHM6Ly9zdGF0aWMtbGVnYWN5LmRpbmd0YWxrLmNvbS9tZWRpYS9sQURQRGdROXJEdHFUZmJOQV9ETkF2UV83NTZfMTAwOC5qcGciLCJ3ZWJUb2tlbiI6bnVsbCwia2V5RHciOjEsImtleUhlcm1lcyI6MSwicmVzb3VyY2VMaXN0IjpudWxsfSwiaXNzIjoiZHdhcGl1c2VyIiwiZXhwIjoxNjMyNzExMjMyLCJuYmYiOjE2MzE0MTUyMzJ9.oYWJXK7sjlFZG8C2RQGFxm9-Ii9HTKElFbyvALLY9pA',
            )
            setToken('userNick', 'xxx')
            setToken('unionid', 'B3NeyiSiS6qUiS7xffQ79iiINQiEiE')
            setToken(
              'userImg',
              'https://gw.alipayobjects.com/zos/rmsportal/jZUIxmJycoymBprLOUbT.png',
            )
            setToken('resourceList', [
              {
                id: 92,
                name: '基础信息',
                code: 'zcmBase',
                application: 'zcm',
                parentId: 89,
                type: 1,
                order: 4,
              },
              {
                id: 94,
                name: '登录',
                code: 'zcmLogin',
                application: 'zcm',
                parentId: 89,
                type: 1,
                order: 1,
              },
              {
                id: 97,
                name: '核算组',
                code: 'zcmHs',
                application: 'zcm',
                parentId: 89,
                type: 1,
                order: 2,
              },
              {
                id: 98,
                name: '税务组',
                code: 'zcmSw',
                application: 'zcm',
                parentId: 89,
                type: 1,
                order: 3,
              },
              {
                id: 99,
                name: '自助开票',
                code: 'zcmSelfInvoice',
                application: 'zcm',
                parentId: 93,
                type: 1,
                order: 6,
              },
              {
                id: 100,
                name: '规划开票',
                code: 'zcmPlanInvoice',
                application: 'zcm',
                parentId: 93,
                type: 1,
                order: 7,
              },
              {
                id: 101,
                name: '非订单开票',
                code: 'zcmUnorderInvoice',
                application: 'zcm',
                parentId: 93,
                type: 1,
                order: 8,
              },
            ])
          } else {
            this.logging = false
            this.$message.error('密码用户出错')
          }
        }
      })
    },
    // 免登录接口
    DingTalkLogin() {
      this.$loginDingUitl(
        code => {
          this.isNeedFormLogin = false
          this.getInitNetWork(code)
        },
        () => {
          console.log('请从钉钉客户端打开')
        },
      )
    },

    getInitNetWork(param) {
      if (/Android|webOS|iPhone|iPad|BlackBerry|WindowsCE/i.test(navigator.userAgent)) {
        this.isShowError = true
        this.errorLabel = '抱歉移动端暂未开放'
        return
      }
      let _code = {
        code: param,
      }
      this.spinning = true
      getLogin2DingTalk(_code)
        .then(res => {
          this.spinning = false
          setToken('webToken', res.data.webToken)
          setToken('unionid', res.data.unionid)
          setToken('userNick', res.data.nick)
          setToken('userImg', res.data.userImg)
          let isShowPermission = {
            keyDw: res.data.keyDw,
            keyHermes: res.data.keyHermes,
          }
          setToken('isShowPermission', isShowPermission)
          // setToken('resourceList', res.data.resourceList)
          // this.$store.commit('setting/setResourceList', res.data.resourceList)
          if (res.code == '2112') {
            //
            // let tmpArr = []
            // if (res.data.resourceList && res.data.resourceList.length > 0) {
            //   tmpArr = res.data.resourceList.filter(v => {
            //     return v.code === 'zcmLogin'
            //   })
            // }
            // if (tmpArr.length > 0) {
            this.$router.push('/mainhome')
            // } else {
            //   this.isShowError = true
            //   this.errorLabel = ' 抱歉暂无权限访问,请联系管理员开通权限'
            // }
          } else {
            this.isShowError = true
            this.errorLabel = res.message.toString()
          }
        })
        .catch(error => {
          console.log('error', error)
          this.spinning = false
          this.isShowError = true
          this.errorLabel = error.toString()
          if (error.response && error.response.data && error.response.data.message) {
            this.errorLabel = '出错:' + error.response.data.code
          }
        })
    },
    //限制客服是否可以登录
    currentUserType() {
      currentUserType()
        .then(res => {
          if (res.code == '2112') {
            setToken('currentUserType', res.data)
          }
        })
        .catch(error => {
          console.log('response', error.response)
          if (error.response && error.response.data) {
            this.$message.error(error.response.data.message)
          }
        })
    },
    //限制是否可见基础设置
    kingdeeDataUser() {
      kingdeeDataUser()
        .then(res => {
          if (res.code == '2112') {
            setToken('kingdeeDataUser', res.data)
            this.$router.push('/mainhome')
          }
        })
        .catch(error => {
          console.log('response', error.response)
          if (error.response && error.response.data) {
            this.$message.error(error.response.data.message)
          }
        })
    },

    loginBrowser() {
      // 清空Token
      if (window.location.href.includes('code')) {
        // this.isDevShow = false
        this.getInitNetWork(this.$route.query.code)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  background: #f0f2f5 url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg')
    no-repeat center 110px;
  background-size: 100%;
  .content {
    padding: 32px 0;
    flex: 1;
    @media (min-width: 768px) {
      padding: 112px 0 24px;
    }
    .top {
      text-align: center;
      .header {
        height: 44px;
        line-height: 44px;
        a {
          text-decoration: none;
        }
        .logo {
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
        }
        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }
    .login {
      width: 368px;
      margin: 0 auto;
      @media screen and (max-width: 576px) {
        width: 95%;
      }
      @media screen and (max-width: 320px) {
        .captcha-button {
          font-size: 14px;
        }
      }
      .icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
.loging-wrapper {
  height: 200px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.ant-spin-dot {
  i {
    background-color: #e84242;
  }
}

/deep/.ant-spin-text {
  color: #e84242;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue